import React, { Component, Fragment } from 'react';

class CartLineItem extends Component {
  increaseQuantity = () => {
    this.props.updateLineQuantity(this.props.product.variant_id, this.props.product.quantity + 1);
  };

  decreaseQuantity = () => {
    this.props.updateLineQuantity(this.props.product.variant_id, this.props.product.quantity - 1);
  };

  removeProduct = () => {
    this.props.updateLineQuantity(this.props.product.variant_id, 0);
  };

  render() {
    const product = this.props.product;
    return (
      <Fragment>
        {
          product.product_id == 4775207731266
            ? null
            : (
              <div className="Card Card--product">
                <figure className="Card__figure">
                  <a href={product.url}>
                    <img src={product.image} alt={product.product_title} />
                  </a>
                </figure>
                <div className="Card__details">
                  <h6 className="Card__title">
                    <a href={product.url}>
                      {product.product_title} {product.variant_title && <small>{product.variant_title}</small>}
                    </a>
                  </h6>
                  <div className="quantity_and_amount">
                    <div className="quantity">
                      <button onClick={this.decreaseQuantity}>-</button>
                      <span className="value">{product.quantity}</span>
                      <button onClick={this.increaseQuantity}>+</button>
                    </div>
                    <div className="amount">${(product.line_price / 100).toFixed(2)}</div>
                    <button className="Button Button--noLayout delete-line" onClick={this.removeProduct} />
                  </div>
                </div>
              </div>
            )
        }
      </Fragment>
    );
  }
}

export default CartLineItem;
